import { Box, Typography } from '@mui/material';
import { PatientProfileInfoAccordionEditable } from '../PatientProfileInfoAccordion';
import { useMemo } from 'react';
import { usePatientMedicationQuery } from '@uplift/queries';
import { MedicationItem } from './MedicationItem.component';
import { MedicationsForm } from '../../../MedicationsForm/MedicationsForm.component';
import { updatePatientMedications } from '@uplift/api';
import { useAlert } from '../../../../../AlertProvider';

export type MedicationAccordianProps = {
  patientId: string;
  editable: boolean;
  inlineForm?: boolean;
};

export type MedicationsFormType = {
  drugs: string[];
};

export const MedicationAccordian: React.VFC<MedicationAccordianProps> = ({ patientId, editable, inlineForm }) => {
  const alert = useAlert();
  const { data: medicationData, refetch } = usePatientMedicationQuery(patientId);

  const initialValues: MedicationsFormType = {
    drugs: medicationData?.homemeds?.map(d => d.drugName) ?? []
  };

  const onSubmit = async (values: MedicationsFormType) => {
    await updatePatientMedications(patientId, values.drugs);

    await refetch();
  };

  const content = useMemo(() => {
    if (!medicationData?.homemeds?.length && !medicationData?.rxorders?.length) {
      return <Typography variant="body2" color="textPrimary">No medications on record</Typography>;
    }

    const { rxorders, homemeds } = medicationData;

    return (
      <Box>
        {[ ...rxorders, ...homemeds ].map(medication => <MedicationItem medication={medication} key={medication.drugName} />)}
      </Box>
    );
  }, [ medicationData ]);

  const form = useMemo(() => {

    return (
      <div>
        {medicationData?.rxorders?.map(medication => <MedicationItem medication={medication} key={medication.drugName} />)}
        <MedicationsForm />
      </div>
    );
  }, [ medicationData?.rxorders ]);

  return (
    <PatientProfileInfoAccordionEditable
      title="Medication"
      editable={editable}
      inlineForm={inlineForm}
      formikConfig={{
        initialValues,
        onSubmit,
      }}
      form={form}
      onSuccess={(onCancelEdit) => {
        alert.success('Medication updated');
        onCancelEdit();
      }}
    >
      {content}
    </PatientProfileInfoAccordionEditable>
  );
};
